const styles = {
  container: {
    padding: '0 !important',
  },
  '@global .ui.table': {
    boxShadow:
      '0 1rem 0 0 rgba(0,0,0,0.03), 0 2rem 6rem 0 rgba(0,0,0,0.06); !important',
  },
  header: {
    fontSize: '1.25em !important',
    fontWeight: 'normal !important' as 'normal',
    marginTop: '0 !important',
    wordWrap: 'break-word !important',
  },
  logo: {
    backgroundColor: '#fff !important',
    border: '.078125em solid #F5F5F5 !important',
    boxSizing: 'border-box !important' as 'border-box',
    height: '2.05937em !important',
    width: '2.15625em !important',
  },
  tableHeader: {
    backgroundColor: '#440C7F !important',
    color: '#fff !important',
    fontWeight: '500 !important',
  },
  selectableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
};

export default styles;
